import { Tabs } from "@aidkitorg/component-library";
import React from "react";
import { CreateDashboardComponentTab } from "./CreateDashboardComponentTab";

const TemplatesTab = () => {
  return (<div>
  </div>)
}

export const DashboardBuilderPanel = () => {
  const tabs = [
    { name: 'Templates', key: 'templates', content: <TemplatesTab /> },
    { name: 'Create', key: 'create', content: <CreateDashboardComponentTab /> }
  ]
  return (<>
    <Tabs unmountTabs tabs={tabs} />
  </>)
}